module.exports = __webpack_public_path__ + "static/media/4.07c516be.jpg";